import Vue from 'vue'
import App from './App.vue'

import axios from 'axios'
import router from "./router"

import day from 'dayjs'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'

window.numeral = require('numeral')
Vue.config.productionTip = false

import Toast from 'vue-toastification'
import "vue-toastification/dist/index.css";

Vue.use(Toast, {
    closeOnClick: true,
    position: "bottom-right"
})

Vue.component('pagination', require('laravel-vue-pagination'));

// Axios defaults
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.baseURL = process.env.VUE_APP_URL;

// Set authorization header
axios.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token')
    if (token !== null) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

// Auth middleware
router.beforeEach((to, from, next) => {
    if (to.matched.some(route => route.meta.auth)) {
        let token = localStorage.getItem('token')
        if (token == null) {
            window.location.href = '/login'
        }
    }
    next();
});

// Always redirect to login if not authenticated
axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response) {
        if (401 === error.response.status) {
            localStorage.removeItem('token')
            router.push(`/login`);
        }
        if (403 === error.response.status) {
            if (router.currentRoute.path != '/verify') {
                router.push(`/verify`);
            }
        }
        // if (500 === error.response.status) {
        //     router.push(`/error`);
        // }
    }
    return Promise.reject(error);
});

// Title middleware
router.afterEach((to) => {
    document.title = 'ERP-Client' + ' - ' + to.meta.title || ''
});

Vue.prototype.$http = axios
Vue.prototype.day = day

Vue.mixin({
    data: function () {
        return {
            wait: false,
            error: '',
            success: ''
        }
    },
    methods: {
        clear() {
            this.error = this.success = ''
        },
        setLoading() {
            this.wait = true
        },
        init() {
            window.scroll(0, 0)
            this.clear()
            this.setLoading()
        },
        showError(error) {
            this.clear()
            if (error.response) {
                this.error = error.response.data.data
            } else if (error.request) {
                this.error = "Connection to ERP server failed"
            } else if (error.message) {
                this.error = "Error: " + error.message
            } else {
                this.error = 'An unknown error occurred'
            }
            this.$toast.error(this.error)
        },
        currency(value) {
            return this.money(value)
        },
        money(value) {
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            return formatter.format(value)
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        }
    }
})

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
